// @ngInject
function SalesApiService($q, $window, DS, DSHttpAdapter, ResourcesService) {

    var endpoint = 'sales';

    return {
        getAllSalesTotals: getAllSalesTotals,
        approveSalesTotal: approveSalesTotal
    };

    function getAllSalesTotals(searchTerms) {
        var deferred = $q.defer();
        var params = {};

        if (!searchTerms) { searchTerms = {}; }

        if (searchTerms.currentPage && searchTerms.currentPage > 1) {
            params.page = searchTerms.currentPage;
        } else {
            params.page = 1;
        }

        if (searchTerms.itemsPerPage && searchTerms.itemsPerPage > 0) {
            params.limit = searchTerms.itemsPerPage;
        } else {
            params.limit = 20;
        }

        if (searchTerms.status && searchTerms.status.length > 0) {
            params.status = searchTerms.status;
        }

        if (searchTerms.locationId && searchTerms.locationId > 0) {
            params.locationId = searchTerms.locationId;
        }

        if (searchTerms.periodStart) {
            params.periodStart = searchTerms.periodStart;
        }
        if (searchTerms.periodEnd) {
            params.periodEnd = searchTerms.periodEnd;
        }

        DSHttpAdapter.GET(DS.defaults.basePath + endpoint + '/totals', { params: params }).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function approveSalesTotal(id) {
        var deferred = $q.defer();

        var params = { id: id, approvalBy: '' };

        DSHttpAdapter.PUT(DS.defaults.basePath + endpoint + '/totals/' + id + '/approval', { params: params }).then(function(response) {
            deferred.resolve(response);
        }, function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('sales.api', [])
    .factory('SalesApiService', SalesApiService);
